var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var AllVideos = /** @class */ (function () {
    function AllVideos(vimeo) {
        var _this = this;
        this.baseUrl = '/me/videos';
        this.paging = {};
        this.getVideos = function (url) { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.vimeo.getUrl(url)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, this.sanitizeResponse(res)];
                }
            });
        }); };
        this.getFirst = function () { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getVideos(this.baseUrl)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res];
                }
            });
        }); };
        this.sortFiles = function (files) { return files.sort(function (fileA, fileB) { return fileB.size - fileA.size; }); };
        // We strip the video here, so we don't upload too much to Sanity
        this.stripVideo = function (video) { return ({
            created_time: video.created_time,
            created_unix_time: new Date(video.created_time).valueOf(),
            description: video.description,
            files: _this.sortFiles(video.files),
            is_playable: video.is_playable,
            link: video.link,
            manage_link: video.manage_link,
            modified_time: video.modified_time,
            modified_unix_time: new Date(video.modified_time).valueOf(),
            name: video.name,
            pictures: video.pictures,
            privacy: video.privacy,
            release_time: video.release_time,
            resource_key: video.resource_key,
            status: video.status
        }); };
        this.getNext = function () { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.paging.next) {
                            console.error('Could not find any next paging call.');
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.getVideos(this.paging.next)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res];
                }
            });
        }); };
        this.getPrevious = function () { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.paging.previous) {
                            console.error('Could not find any previous paging call.');
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.getVideos(this.paging.previous)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res];
                }
            });
        }); };
        this.vimeo = vimeo;
    }
    AllVideos.prototype.sanitizeResponse = function (response) {
        if (!response) {
            console.error('Response was empty');
            return;
        }
        this.paging = response.paging;
        var strippedVideos = [];
        for (var _i = 0, _a = response === null || response === void 0 ? void 0 : response.data; _i < _a.length; _i++) {
            var video = _a[_i];
            strippedVideos.push(this.stripVideo(video));
        }
        response.data = strippedVideos;
        response.max_index = Math.round((response.total || 1) / (response.per_page || 1));
        return response;
    };
    return AllVideos;
}());
export default AllVideos;
